export enum ROLES {
  HOSPITAL = 'HOSPITAL',
  SUB_HOSPITAL = 'SUB_HOSPITAL',
  INSTITUTION = 'INSTITUTION'
}
export enum BD_PAGE_INVOKE_TYPE {
  HOSPITAL_ONBOARDING = 'hospitalOnboarding',
  LOYALTY_CONVERSION  = 'loyaltyConversion',
  APPROVE_HOSPITAL    = 'approveHospital'
}
export enum FXN_OPERATION_TYPE {
  PARSE_NUMBERS       = 'parse',
  REMOVE_NULL_VALUES  = 'remove'
}
export enum COMMON_DATE_FORMATS {
  yyyy_MM_dd            = 'yyyy-MM-dd',
  YYYY_MM_DD_hh_mm_ss   = 'yyyy-MM-DD hh:mm:ss',
  YYYY_MM_DD            = 'YYYY-MM-DD',
  DD_MM_YYYY            = 'DD-MM-YYYY',
  hh_mm_A               = 'hh:mm A',
  HH_mm_ss              = 'HH:mm:ss',
  YYYY_MM_DD_hh_mm_ss_A = 'yyyy-MM-DD hh:mm:ss A',
  DD_MM_YYYY_hh_mm_A    = 'DD-MM-YYYY hh:mm A'
}``
export enum IPD_REFUND_TABS {
  INITIATE_REFUND = 'Initiate Refund',
  PROCESS_REFUND  = 'Process Refund',
  FTR_TRIGGERED   = 'FTR Triggered',
  REFUND_HISTORY  = 'Refund History'
}
export enum IPD_REFUND_STATUS {
  INITIATED     = 'INITIATED',
  PROCESSED     = 'PROCESSED',
  FTR_TRIGGERED = 'FTR_TRIGGERED',
  TRANSFERRED   = 'TRANSFERRED'
}

export enum TXN_SETTLEMENT_QR_TABS {
  PROCESS_TRANSFER = 'Process Transfer',
  MARKED_fOR_FTR   = 'Marked For FTR',
  TRANSFER_HISTORY = 'Transfer History',
}
export enum TRIGGER_REPORT_TABS {
  DAILY_TRIGGER_REPORT = 'DAILY_TRIGGER_REPORT',
  TRIGGERED_REPORTS    = 'TRIGGERED_REPORTS'
}
export enum AC_TYPE {
  HOSPITAL = 'HOSPITAL'
}
export enum APPROVAL_STATUS {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING  = 'PENDING'
}
export enum MODES_OF_PAYMENT {
  CASH_AT_HOSPITAL = 'CASH_AT_HOSPITAL'
}
export enum PAYMENT_TYPES {
  CASHBACK = 'CASHBACK',
  AP_CASHBACK_POINTS = 'AP_CASHBACK_POINTS'
}
export enum STATUS_OPTIONS {
    ALL     = "ALL",
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
    ONGOING = 'ONGOING'
}
export enum FILE_TYPES {
  IMAGE       = 'IMAGE',
  PDF         = 'PDF',
  BASE64      = 'BASE64',
  IMAGE_ARRAY = 'IMAGE_ARRAY'
}
export enum CUSTOMER_DOCS {
  PHOTO          = 'PHOTO',
  PANCARD        = 'PANCARD',
  ADDRESS_PROOF  = 'ADDRESS_PROOF',
  BANK_STATEMENT =  'BANK_STATEMENT'
}

export enum HOSPITAL_APPOINTMENT_STATUS {
  PENDING               = 'PENDING',
  CONFIRMED             = 'CONFIRMED',
  CANCELLED_BY_HOSPITAL = 'CANCELLED_BY_HOSPITAL',
  CANCELLED_BY_CUSTOMER = 'CANCELLED_BY_CUSTOMER',
  ATTENDED              = 'ATTENDED',
  RESCHEDULED           = 'RESCHEDULED',
  PATIENT_NO_SHOW       = 'PATIENT_NO_SHOW'
}

export enum LOAN_LEAD_STATUS {
  DOCS_REQUESTED              = 'DOCS_REQUESTED',
  DOCS_RECEIVED               = 'DOCS_RECEIVED',
  SENT_TO_NBFC                = 'SENT_TO_NBFC',
  APPROVED                    = 'APPROVED',
  REJECT                      = 'REJECT',
  DP_REQUESTED                = 'DP_REQUESTED',
  CONFIRMATION_SENT           = 'CONFIRMATION_SENT',
  DISBURSED                   = 'DISBURSED',
  POST_APPROVAL_DOCUMENTATION = 'POST_APPROVAL_DOCUMENTATION'
}


export enum LOAN_TABS {
  LOAN_OPS = 'LOAN_OPS',
  LOAN = "LOAN",
  LOAN_LEAD_LIST = 'LOAN_LEAD_LIST'
}

export enum NBFC_STATUS {
  ACTIVE        =   'ACTIVE',
  INACTIVE      =   'INACTIVE'
}

export enum LOCATIONS_TABS {
  CITY     = 'CITY',
  LOCATION = 'LOCATION',
  REGION   = 'REGION',
  ZONE     = 'ZONE'
}

export enum POS_TRANSACTIONS_TABS {
  PROCESSED       = 'PROCESSED',
  NOT_PROCESSED   = 'NOT_PROCESSED',
  POS_INITIATIONS = 'POS_INITIATIONS'
}
